import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {MainComponent} from './core/main/main.component';
import {AuthComponent} from './modules/auth/auth.component';
import {AuthGuard} from './guard/auth.guard';

const ROUTES: Routes = [
  {
    path: 'login',
    component: AuthComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: './modules/home/home.module#HomeModule',
      },
      {
        path: 'category',
        loadChildren: './modules/category/category.module#CategoryModule',
      },
      {
        path: 'product',
        loadChildren: './modules/product/product.module#ProductModule',
      },
      {
        path: 'accessory',
        loadChildren: './modules/accessory/accessory.module#AccessoryModule',
      },
      {
        path: 'lot',
        loadChildren: './modules/lot/lot.module#LotModule',
      },
      {
        path: 'user',
        loadChildren: './modules/user/user.module#UserModule',
      },
      {
        path: 'sms',
        loadChildren: './modules/sms/sms.module#SmsModule',
      },
      {
        path: 'pages',
        loadChildren: './modules/pages/pages.module#PagesModule',
      },
      {
        path: 'banner',
        loadChildren: './modules/banner/banner.module#BannerModule',
      },
      {
        path: 'reports',
        loadChildren: './modules/reports/reports.module#ReportsModule',
      },
      {
        path: 'admin',
        loadChildren: './modules/admin-user/admin-user.module#AdminUserModule',
      },
      {
        path: 'referral',
        loadChildren: './modules/referral/referral.module#ReferralModule',
      },
    ],
  },
  {path: '**', redirectTo: 'login'},
];

@NgModule({
  imports: [
    RouterModule.forRoot(ROUTES, {scrollPositionRestoration: 'enabled'}),
  ],
  declarations: [],
})
export class AppRoutingModule {}
